import React, { useEffect } from "react";
import Button from "../components/Button";
import solar_installing from "../components/assets/solar-installing.jpg";
import solar_product from "../components/assets/solar-panel-installation-services-305.jpg";
import solar_maintenance from "../components/assets/solar-panel-repair.webp";
import solar_financing from "../components/assets/solar_financing.avif";
import solar_panels from "../components/assets/panels-electricity-order-sunlight.webp";
import AOS from "aos";
import "aos/dist/aos.css";
import Cta from "../components/Cta";
import Seo from '../components/Seo';
const services = [
  {
    title: "Solar Panel Installation",
    description:
      "High-efficiency solar panels installed by experts, designed for your roof & energy needs.",
    image:
      solar_installing,
  },
  {
    title: "Solar Product Supply",
    description:
      "Premium solar panels, inverters, batteries & accessories from trusted brands.",
    image: solar_product,
  },
  {
    title: "Maintenance & Repair",
    description:
      "Routine check-ups & quick repairs to keep your system at peak performance.",
    image:
      solar_maintenance,
  },
  {
    title: "Solar Financing",
    description:
      "Flexible financing & leasing to make solar affordable for everyone.",
    image:
      solar_financing,
  },
];

const steps = [
  { step: "🔍", title: "Consultation", description: "Free solar assessment tailored to your needs." },
  { step: "📐", title: "Design", description: "Custom-engineered system for your property." },
  { step: "⚡", title: "Installation", description: "Fast, precise & professional setup." },
  { step: "🛠️", title: "Maintenance", description: "Ongoing support & monitoring." },
];

const benefits = [
  "Lower electricity bills",
  "Reduce carbon footprint",
  "Increase property value",
  "Energy independence",
  "Low maintenance costs",
  "Government incentives & subsidies",
];

const ServicesPage = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false
    });
  }, []);

  return (
    <>
      <Seo
        title="Solar Services in Kutch | Solar Panel Installation Gujarat"
        description="Discover Boost Solar's installation, maintenance, financing, and solar product solutions for homes, businesses, and industry in Gujarat."
        url="https://kksolar.co.in/services"
      />
      <div className="max-w-8xl mt-24 mx-auto font-sans overflow-hidden">
      {/* Hero Section */}
      <section className="relative min-h-[70vh] bg-gradient-to-br from-primary via-secondary to-blue-900 flex items-center justify-center overflow-hidden">
      
        <div 
          className="relative text-center max-w-4xl px-6 space-y-8"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <div 
            className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full border border-white/20"
            data-aos="fade-down"
            data-aos-delay="400"
          >
            <span className="w-3 h-3 bg-opprimary rounded-full mr-3 animate-pulse"></span>
            <span className="text-white font-semibold text-lg">Professional Solar Services</span>
          </div>
          
          <h1 
            className="text-5xl lg:text-6xl font-bold text-white leading-tight"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Power Your <span className="text-opprimary">Future</span>
          </h1>
          
          <p 
            className="text-xl opacity-90 max-w-3xl mx-auto leading-relaxed text-white"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            Complete solar energy solutions from design to maintenance — clean, reliable & affordable.
          </p>

          <div 
            className="flex flex-col sm:flex-row gap-6 justify-center items-center pt-8"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <Button variant="solidorange" className="text-lg px-8 py-4"
              href="/solar-calculator">
              Get Free Consultation
            </Button>
           
          </div>
        </div>

      </section>

      {/* Services Section */}
      <section className="px-6 py-20 bg-background relative overflow-hidden">
        {/* Background Animation */}
        <div className="absolute inset-0 bg-gradient-to-br from-opprimary/5 to-primary/5 animate-gradient-x"></div>
        
        <h2 
          className="text-4xl font-bold text-center mb-14 text-primary"
          data-aos="fade-up"
        >
          What We Offer
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 200}
              className="group"
            >
              <div className="bg-white/80 backdrop-blur-lg rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transform hover:-translate-y-4 transition-all duration-500 border border-gray-100">
                <div className="relative overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-60 object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-primary mb-3 group-hover:text-secondary transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                  
                  {/* <div className="mt-4">
                    <Button variant="outline" className="w-full justify-center transform group-hover:scale-105 transition-transform duration-300">
                      Learn More
                    </Button>
                  </div> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* How We Work Section */}
      <section className="py-20 bg-white relative overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
        
        <h2 
          className="text-4xl font-bold text-center mb-14 text-primary"
          data-aos="fade-up"
        >
          How We Work
        </h2>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 px-6 max-w-7xl mx-auto">
          {/* Connecting Line for Desktop */}
          <div className="hidden lg:block absolute top-1/2 left-1/4 right-1/4 h-1 bg-gradient-to-r from-transparent via-opprimary to-transparent transform -translate-y-1/2"></div>
          
          {steps.map((step, index) => (
            <div
              key={index}
              data-aos="flip-up"
              data-aos-delay={index * 200}
              className="relative group"
            >
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 border border-gray-100 text-center relative overflow-hidden">
                {/* Step Number Background */}
                <div className="absolute top-4 right-4 text-6xl font-bold text-gray-100">
                  {index + 1}
                </div>
                
                {/* Animated Icon */}
                <div 
                  className="text-5xl mb-6 transform group-hover:scale-110 group-hover:rotate-12 transition-transform duration-300"
                >
                  {step.step}
                </div>
                
                <h4 className="text-xl font-bold text-primary mb-3 group-hover:text-secondary transition-colors duration-300">
                  {step.title}
                </h4>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
                
                {/* Hover Effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-opprimary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Benefits Section */}
      <section className="px-6 py-20 bg-background relative overflow-hidden">
        {/* Animated Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-opprimary/5 animate-gradient-xy"></div>
        
        <h2 
          className="text-4xl font-bold text-center mb-14 text-primary"
          data-aos="fade-up"
        >
          Why Choose Solar Energy?
        </h2>

        <div 
          className="grid md:grid-cols-2 gap-12 items-center max-w-7xl mx-auto"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {/* Image */}
          <div 
            className="relative group"
            data-aos="fade-right"
            data-aos-delay="300"
          >
            <div className="rounded-2xl overflow-hidden shadow-lg transform group-hover:shadow-2xl transition-all duration-500">
              <img
                src={solar_panels}
                alt="Solar Benefits"
                className="w-full h-[400px] object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          </div>

          {/* Benefits List */}
          <div 
            className="space-y-6"
            data-aos="fade-left"
            data-aos-delay="400"
          >
            <ul className="space-y-6">
              {benefits.map((benefit, index) => (
                <li 
                  key={index}
                  className="flex items-center group cursor-pointer transform hover:-translate-x-2 transition-transform duration-300"
                >
                  <span className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-opprimary to-primary text-white rounded-full shadow-lg mr-4 text-lg font-bold transform group-hover:scale-110 transition-transform duration-300">
                    ✓
                  </span>
                  <span className="text-lg text-gray-700 group-hover:text-primary transition-colors duration-300">
                    {benefit}
                  </span>
                </li>
              ))}
            </ul>
            
            <div className="pt-6" data-aos="fade-up" data-aos-delay="600">
              <Button variant="solidorange" className="w-full sm:w-auto"
              href="/solar-calculator">
                Calculate Your Savings
              </Button>
            </div>
          </div>
        </div>

     
      </section>

      {/* CTA Section */}
      <Cta/>


      <style jsx>{`
        .bg-grid-pattern {
          background-image: linear-gradient(rgba(2, 26, 92, 0.1) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(2, 26, 92, 0.1) 1px, transparent 1px);
          background-size: 50px 50px;
        }
        
        @keyframes gradient-x {
          0%, 100% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
        }
        
        @keyframes gradient-xy {
          0%, 100% { background-position: 0% 0%; }
          50% { background-position: 100% 100%; }
        }
        
        .animate-gradient-x {
          animation: gradient-x 15s ease infinite;
          background-size: 400% 400%;
        }
        
        .animate-gradient-xy {
          animation: gradient-xy 15s ease infinite;
          background-size: 400% 400%;
        }
      `}</style>
    </div>
    </>
  );
}

export default ServicesPage;